import React, { useMemo } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { ApplicantRouteAPI as API, Props } from './ApplicantRouteWrapper.types';

const ApplicantRouteWrapper: React.FC<Props> = ({ children, applicantIds }) => {
  const match = useRouteMatch<{ slug: string }>();
  const applicantNumber = useMemo(() => {
    return Number(match.params.slug);
  }, [match.params.slug]);

  const api: API = {
    applicantId: applicantIds[applicantNumber - 1],
    applicantNumber: Number(match.params.slug),
  };

  return <>{children(api)}</>;
};

export default ApplicantRouteWrapper;
